import React from 'react'
import classNames from 'classnames'
import RichText from '@src/quince-site-common/src/domains/RichText'
import { RichText as RichTextClass, RichTextProps } from '../../molecules'
import ProductComparisonTable, { ProductComparisonProductProps } from './ProductComparisonTable'

import styles from './productComparison.module.scss'

export interface ProductComparisonProps {
  header: RichText
  rowHeaders: RichText[]
  columns: ProductComparisonProductProps[]
  className?: string | undefined
  headerClassName?: string | undefined
  tableClassName?: string | undefined
}

const ProductComparison = ({
  header,
  rowHeaders,
  columns,
  className,
  headerClassName,
  tableClassName,
}: ProductComparisonProps) => {
  const classes = classNames(styles.comparisonWrapper, className)
  const headerRichTextProps: RichTextProps | undefined = RichText.makeRichTextProps(header)

  return (
    <div className={classes}>
      <div className={`${styles.wrapper__text} ${headerClassName || ''}`}>
        {header && headerRichTextProps && <RichTextClass {...headerRichTextProps} />}
      </div>
      <ProductComparisonTable rowHeaders={rowHeaders} columns={columns} className={tableClassName} />
    </div>
  )
}

export default ProductComparison
